module.exports = __webpack_public_path__ + "static/home_eye_catching-e2eee3667c64096b0ef278be0d2d4ff9.png";